const skillsData = {
  1: [
    {
      title: 'HTML',
      level: 6,
    },
    {
      title: 'CSS',
      level: 5,
    },
    {
      title: 'JavaScript',
      level: 5,
    },

    {
      title: 'TailwindCSS',
      level: 3,
    },
    {
      title: 'ReactJS',
      level: 5,
    },
    {
      title: 'Figma',
      level: 3,
    },
  ],

  2: [
    {
      title: 'Node.JS',
      level: 5,
    },
    {
      title: 'MongoDB',
      level: 4,
    },
    {
      title: 'PhP',
      level: 1,
    },

    {
      title: 'Git',
      level: 6,
    },
    {
      title: 'Express.js',
      level: 5,
    },
  ],
}

export default skillsData
